import { Box, Button, colors, Typography } from '@mui/material'
import React from 'react'
import { Icon } from '@iconify/react'

import { t } from 'i18next'

function RenewalBanner({ open, stripe_id }: { open: boolean, stripe_id?: string }) {

    return (
        <Box bgcolor={'#ffcc00'} position={'relative'} width={'100%'} pl={3} pr={2} py={1.5} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
            <Typography color={'black'} variant='body2' alignItems={'center'} display={'flex'} gap={1}>
                <Icon icon='cuida:warning-outline' width={20} height={20}></Icon>
                {t('renewalBanner:description')}</Typography>

            {
                stripe_id && <Button component='a' href={process.env.REACT_APP_BACKOFFICE_BILLING_URI?.concat(stripe_id)} target='_blank' rel='noreferrer' sx={{ color: 'black' }}>{t('menu:billing')}</Button>
            }

        </Box>
    )
}

export default RenewalBanner